<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64">
    <g fill="none" fill-rule="evenodd">
        <g fill="#000">
            <g>
                <path class="fill" d="M33.886 8.781c.96.961 1.035 2.474.221 3.52l-.221.251-16.78 16.781H56c1.473 0 2.667 1.194 2.667 2.667 0 1.368-1.03 2.495-2.356 2.649l-.311.018-38.895-.001 16.78 16.782c.962.961 1.036 2.474.222 3.52l-.221.251c-.962.961-2.474 1.035-3.52.222l-.252-.222L8.781 33.886c-.961-.962-1.035-2.474-.222-3.52l.222-.252L30.114 8.781c1.042-1.041 2.73-1.041 3.772 0z" transform="translate(-66 -751) translate(66 751)"/>
            </g>
        </g>
    </g>
</svg>
